export function OnboardingJourneyFilledSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/onboarding-journey-filled.svg'"></ng-include>`
    }
}